<template>
    <div    class="w-full flex justify-center">
        <div    class="w-1/3">
            <div    class="mb-8">
                <p>
                    Set a User to have a particular permission level across all sites they can access.  This,
                    coupled with sonicu users being automatically set to have access to all customer sites should
                    ease the process of shifting between Sonicu View Only & Sonicu or other Permission levels
                    at the sonicu organization level.
                </p>
            </div>

            <div    class="flex items-center justify-between">
                <div    class="w-1/2 flex items-center">
                    <span>User</span>
                    <div    class="ml-2 w-2/3">
                        <select2    :options="users"
                                    v-model:value="user"
                                    :close-on-select="true"
                        ></select2>
                    </div>
                </div>

                <div    class="w-1/2 flex items-center">
                    <span>Permission Level</span>
                    <div class="ml-2 w-2/3">
                        <select2    :options="permissionLevels"
                                    v-model:value="permissionLevel"
                                    :close-on-select="true"
                        ></select2>
                    </div>

                </div>
            </div>

            <div    class="cursor-pointer"
                    @click="assignRole">
                <div    v-if="!saving"
                        class="w-full">
                    <div    v-if="user !== null && permissionLevel !== null"
                            class="w-full">
                        <green-button>Assign Permission Level</green-button>
                    </div>
                    <div     v-else
                             class="w-full">
                        <green-button>Select User & Permission Level</green-button>
                    </div>
                </div>
                <div    v-else>
                    <green-button>Saving...Please Wait.</green-button>
                </div>

            </div>

            <div    class="">
                <banner-success
                    v-model:is-open="saveSuccess"
                    :auto-hide="5000">
                    <template   #title>
                        Saved Successfully
                    </template>
                    <template   #content>
                        {{ saveMessage }}
                    </template>
                </banner-success>

                <banner-error
                    v-model:is-open="saveError"
                    :auto-hide="5000">
                    <template   #title>
                        Error Saving
                    </template>
                    <template   #content>
                        {{ saveMessage }}
                    </template>
                </banner-error>
            </div>
        </div>
    </div>
</template>

<script>

import axios from "axios"
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import Select2 from "@/components/elements/select2";
import GreenButton from "@/components/elements/green-button";
import BannerSuccess from "@/components/Banners/BannerSuccess";
import BannerError from "@/components/Banners/BannerError";

export default {
    name: "MassAssignRoles",
    mixins: [iconNamesMixin],
    components: {BannerError, BannerSuccess, GreenButton, Select2},
    props: {
        usersInput: Object,
        rolesInput: Object,
    },
    data() {
        return {
            permissionLevels: {
            },
            users: {
            },
            user: null,
            permissionLevel: null,

            saving: false,
            saveSuccess: false,
            saveError: false,
            saveMessage: '',
        }
    },
    created() {
        this.permissionLevels = this.rolesInput
        this.users = this.usersInput
        this.permissionLevel = Object.keys(this.permissionLevels)[0]
    },
    mounted() {

    },
    methods: {
        assignRole() {
            if (this.saving || _.isNil(this.user) || _.isNil(this.permissionLevel)) {
                return
            }

            console.log(`Assigning User: ${this.user}  |  Role: ${this.permissionLevel}`)
            this.saveSuccess = false
            this.saveError = false
            this.saving = true
            axios.post('/api-internal/SonicuTools/mass-assign-roles', {
                userId: this.user,
                roleName: this.permissionLevel,
            }).then(response => {
                this.saveSuccess = true
                this.saveMessage = response.data
            }).catch(error => {
                this.saveError = true
                this.saveMessage = error
            }).then(() => {
                this.saving = false
                setTimeout(() => {
                    this.saveError = false
                    this.saveSuccess = false
                    this.saveMessage = ''
                }, 5000)
            })
        }
    },
    computed: {

    },
    watch: {

    },
}

</script>

<style scoped>

</style>